export default __webpack_public_path__ + "static/media/DO.34d3c494.svg";